module.exports = __webpack_public_path__ + "static/img/coches-big-black.a3c0745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coches-big-black.png
// module id = 254
// module chunks = 1